// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 736) return "vendor.b619061114d7fcc27fb5.css";
	if (chunkId === 179) return "main.65f384443eaf0ba65fbe.css";
	// return url for filenames based on template
	return "" + (chunkId === 935 ? "scheduler" : chunkId) + "." + chunkId + "." + {"460":"87ce6e7b9c820f531d36","935":"c18afecfe3756d8060f9"}[chunkId] + ".css";
};